<template>
    <loader v-if="$loadingRouteData"></loader>

    <div v-if="!$loadingRouteData"
         class="container -clients-detail">
        <ol class="breadcrumb">
            <li><a v-link="{name: 'home'}">Accueil</a></li>
            <li><a v-link="{name: 'clients'}">Membres</a></li>
            <li>{{ client.name }}</li>
        </ol>

        <div class="header f -wrap -gutter-small">
            <div class="title expand">
                <h1>
                    <editable-text
                        :value.sync="client.name"
                        placeholder="Nom du membre"
                    ></editable-text>
                </h1>
                <h3>
                    {{{
                        client.capital | money
                    }}}&nbsp;/&nbsp;{{{
                        client.payment | money
                    }}}
                </h3>
            </div>
            <div class="actions"
                 v-if="tab === 'recap'">
                <a @click.prevent="showModalSelectClient"
                   class="btn btn-info btn-secondary -contact-merge">
                    <i class="glyphicon glyphicon-plus"></i>
                    Fusionner
                </a>
            </div>
            <div class="actions"
                 v-if="tab === 'recap'">
                <a v-link="{name: 'contracts-add', params: {id: client.id}}"
                   class="btn btn-default -add-contract">
                    <i class="glyphicon glyphicon-plus"></i>
                    Ajouter un contrat
                </a>
            </div>
            <div class="actions"
                 v-if="tab === 'documents'">
                <a @click.prevent="chooseDocumentFile"
                   class="btn btn-default -add-contract">
                    <i class="glyphicon glyphicon-plus"></i>
                    Ajouter un document
                </a>
            </div>
            <div class="actions">
                <a class="btn btn-primary"
                   @click.prevent="addExchange">
                    <i class="glyphicon glyphicon-plus" v-if="!loadAddExchange"></i>
                    <loader :inline="true" v-if="loadAddExchange"></loader>
                    Ajouter un échange
                </a>
            </div>
        </div>

        <ul class="nav nav-tabs" role="tablist">
            <li role="presentation"
                :class="{active: tab === 'recap'}">
                <a @click.prevent="switchTab('recap')"
                   href="#"
                   role="tab">
                    Récap
                </a>
            </li>
            <li role="presentation"
                :class="{active: tab === 'documents'}">
                <a @click.prevent="switchTab('documents')"
                   href="#"
                   role="tab">
                    Documents
                </a>
            </li>
            <li role="presentation"
                :class="{active: tab === 'exchanges'}">
                <a @click.prevent="switchTab('exchanges')"
                   href="#"
                   role="tab">
                    Échanges
                </a>
            </li>
            <li role="presentation"
                :class="{active: tab === 'as-projects'}">
                <a @click.prevent="switchTab('as-projects')"
                   href="#"
                   role="tab">
                    Non-souscrits
                </a>
            </li>
        </ul>

        <exchange-modal
            :client="client"
            :contracts.sync="contracts">
        </exchange-modal>
        <select-client-modal
            class="-select-client"
            :on-select="onSelectClientToMerge">
        </select-client-modal>
        <select-contracts-modal
            :on-validate="onSelectContractsToMerge">
        </select-contracts-modal>
        <select-contacts-modal>
        </select-contacts-modal>

        <div class="row" v-if="tab === 'recap'">
            <div class="col-sm-5 col-md-4 col-lg-3 client-contacts">
                <div class="f -a-center -gutter-small client-status">
                    <radio-group :value.sync="client.status">
                        <radio-btn value="client">Membre</radio-btn>
                        <radio-btn value="prospect">Prospect</radio-btn>
                    </radio-group>

                    <loader :inline="true"
                            v-if="loading"></loader>
                </div>

                <div class="f -a-center -gutter-small client-sources">
                    <checkbox-group :value.sync="client.sources"
                                    type="info">
                        <checkbox-btn value="activeseed">AS</checkbox-btn>
                        <checkbox-btn value="alpinia">AF</checkbox-btn>
                    </checkbox-group>
                </div>

                <contact-column :client.sync="client"></contact-column>
            </div>
            <div class="col-sm-7 col-md-8 col-lg-9">

                <h2>Contrats</h2>

                <exchanges-box :client="client"
                               v-if="client.exchanges.length"></exchanges-box>

                <contract-box v-for="contract in contracts"
                              :contract.sync="contract"></contract-box>
            </div>
        </div>

        <div v-if="tab === 'documents'">
            <documents-tab :client="client"></documents-tab>
        </div>

        <div v-if="tab === 'exchanges'">
            <exchanges-tab :client="client"></exchanges-tab>
        </div>

        <div v-if="tab === 'as-projects'">
            <as-projects-tab :client="client"></as-projects-tab>
        </div>
    </div>
</template>

<style lang="less"
       scoped>
    @import '~src/style/variables';

    .search-area {
        margin-bottom: @grid-gutter-width;
    }

    .header {
        margin-top: @grid-gutter-width;

        h1, h3 {
            margin: 0;
        }

        .actions {
            text-align: right;
        }
    }

    .client-status,
    .client-sources {
        margin-bottom: @grid-gutter-width;
    }

    .nav-tabs {
        margin: @grid-gutter-width 0;
    }

    .row.-documents > .box {
        float: none;
        display: inline-block;
        vertical-align: top;
    }

    .load-more {
        margin: @grid-gutter-width 0;
        text-align: center;
    }
</style>

<!--suppress ExceptionCaughtLocallyJS -->
<script type="text/ecmascript-6">
    import Vue from 'vue';
    import {
        fetch as fetchClient,
        setStatus as setClientStatus,
        update as updateClient,
        merge as mergeClient
    } from '../api/client';
    import {list as listContracts} from '../api/contract';
    import {listForClient} from '../api/todo';
    import {listAllCached as listAllCachedDocs} from '../api/document_types';
    import {getAllCompanies} from '../api/companies';
    import {manager as msgManager} from '../messages';
    import Loader from '../components/Loader';
    import ContractBox from '../components/clients/ContractBox';
    import ContactColumn from '../components/clients/ContactColumn';
    import ExchangesBox from '../components/clients/ExchangesBox.vue';
    import ExchangesTab from '../components/clients/ExchangesTab.vue';
    import DocumentsTab from '../components/clients/DocumentsTab';
    import AsProjectsTab from '../components/clients/AsProjectsTab';
    import ExchangeModal from '../components/clients/ExchangeModal.vue';
    import TodoBox from '../components/clients/TodoBox.vue';
    import EditableText from '../components/editable/EditableText';
    import SelectClientModal from '../components/clients/SelectClientModal';
    import SelectContractsModal from '../components/clients/SelectContractsModal';
    import SelectContactsModal from '../components/clients/SelectContactsModal';
    import RadioGroup from 'vue-strap/src/radioGroup';
    import RadioBtn from 'vue-strap/src/radioBtn';
    import CheckboxGroup from 'vue-strap/src/checkboxGroup';
    import CheckboxBtn from 'vue-strap/src/checkboxBtn';
    import equals from 'equals';
    import router from '../router';
    import {asyncAction, makeUpdateList} from '../utils';
    import dropZone from '../directives/drop-zone';
    import {listOrphans as listOrphanDocs} from '../api/documents';

    export default {
        components: {
            SelectContactsModal,
            ContactColumn,
            ContractBox,
            DocumentsTab,
            ExchangesBox,
            ExchangesTab,
            AsProjectsTab,
            ExchangeModal,
            SelectClientModal,
            SelectContractsModal,
            EditableText,
            TodoBox,
            Loader,
            CheckboxGroup,
            CheckboxBtn,
            RadioGroup,
            RadioBtn
        },
        directives: {
            dropZone
        },
        data() {
            return {
                tab: 'recap',
                msgManager: msgManager,
                merged: false,
                oldStatus: undefined,
                oldSources: undefined,
                oldName: undefined,
                contracts: [],
                todoPage: 1,
                todoHasNext: false,
                todoLoading: false,
                client: {},
                loading: false,
                loadAddExchange: false
            };
        },
        route: {
            data: async function (transition) {
                try {
                    const client = await fetchClient(transition.to.params.id);
                    const contracts = await listContracts(client.id);
                    await getAllCompanies();
                    await listAllCachedDocs();

                    this.client = client;
                    await this.updateTodoList();

                    return {client, contracts};
                } catch (e) {
                    router.replace({name: 'not-found'});
                }
            }
        },

        methods: {
            switchTab(tab) {
                this.tab = tab;

                if (tab === 'recap') {
                    this.updateTodoList();
                }
            },
            addExchange: asyncAction('loadAddExchange', async function () {
                const docs = (await listOrphanDocs(this.client)).results;
                this.$broadcast('client-add-exchange', docs);
            }),
            chooseDocumentFile() {
                this.$broadcast('choose-document-file');
            },
            /**
             * Called when the user already have dnd and selected what info
             * he wants, this method call the API, send a notification in
             * case of success, then redirect the user to the newly created
             * client page
             */
            merge: asyncAction('loading', async function (client = this.client, client2) {
                const res = await mergeClient(client, client2);
                this.merged = true;
                msgManager.push(
                    'Succès.',
                    'Les contacts ont bien été fusionnés',
                    'success'
                );
                router.replace({name: 'clients-detail', params: {id: res.client}});
            }),
            save: asyncAction('loading', async function (client = this.client) {
                this.client = await updateClient(client);
                msgManager.push(
                    'Succès.',
                    'Les infos client ont bien été mises à jour',
                    'success'
                );
            }),
            updateTodoList: makeUpdateList({
                loading: 'todoLoading',
                page: 'todoPage',
                hasNext: 'todoHasNext',
                list: 'todoList',
                fetch: async function (page) {
                    return await listForClient(this.client.id, page);
                }
            }),
            /**
             * Open the modal select client
             */
            showModalSelectClient() {
                this.$broadcast(
                    'client-merge',
                    this.client.sources,
                    this.client,
                );
            },
            /**
             * Open the modal that let the user select contracts to merge
             * call when the user click on the select button from the select
             * client modal
             * @param client
             */
            onSelectClientToMerge(client) {
                this.$broadcast(
                    'client-merge-contracts-select',
                    [this.client, client],
                );
            },
            /**
             * Open the modal that let the user merge the contacts information
             * @param clients array of clients to merge
             * @param contracts array of contracts that should be kept
             */
            onSelectContractsToMerge(clients, contracts) {
                this.$broadcast(
                    'client-merge-contacts-select',
                    clients,
                    contracts,
                );
            }
        },
        watch: {
            'client.sources': {
                deep: true,
                handler: asyncAction('loading', async function (sources) {
                    if (sources instanceof Array && this.client && this.client.id) {
                        if (this.oldSources === undefined) {
                            this.oldSources = sources.slice();
                            return;
                        }

                        if (equals(sources, this.oldSources)) {
                            return;
                        }

                        this.oldSources = sources.slice();
                        if (this.merged) return;
                        await this.save();
                    }
                })
            },
            'client.name': {
                handler: asyncAction('loading', async function (name) {
                    if (name && this.client && this.client.id) {
                        if (this.oldName === undefined) {
                            this.oldName = name;
                            return;
                        }

                        if (!this.client.name) {
                            return;
                        }
                        if (this.merged) return;
                        await this.save();
                    }
                })
            },
            'client.status': asyncAction('loading', async function (status) {
                if (status && this.client && this.client.id) {
                    if (this.oldStatus === undefined) {
                        this.oldStatus = status;
                        return;
                    }
                    if (this.merged) return;
                    try {
                        await setClientStatus(this.client.id, status);
                        msgManager.push(
                            'Succès.',
                            'Le statut du client a été changé',
                            'success'
                        );
                    } catch (e) {
                        msgManager.push(
                            'Erreur.',
                            'Impossible de changer le statut du client.',
                            'danger'
                        );
                    }
                }
            })
        },
        events: {
            'save-client': function (client = this.client) {
                this.save(client);
            },
            'merge-client': function (client = this.client, client2) {
                this.merge(client, client2);
            },
            'search-document': function (name) {
                this.switchTab('documents');
                Vue.nextTick(() => {
                    this.$broadcast('search-document', name);
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ClientsDetail.vue?65ab13ea